<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 0;
  height: 100%;
  width: 100%;
  position: fixed;
  top:0;
  left:0;
  right:0;
  bottom:0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue